export const translation = {
    button: {
        label: 'Deployments Overview',
        title: 'List of all the transformations deployed in your Snowflake account'
    },
    page: {
        title: 'Deployments',
        deletedInDatameer: 'Deleted in Datameer',
        columns: {
            snowflakeFQN: 'Snowflake Target',
            deployedFrom: 'Deployed From',
            deployedAs: 'Deployed As',
            deployedAt: 'Deployed At',
            owner: 'Owner'
        },
        filter: {
            findByName: {
                placeholder: 'Find dataset…'
            }
        },
        close: 'Close'
    }
};
